import { render } from "./CertificateList.vue?vue&type=template&id=3044cec2&scoped=true"
import script from "./CertificateList.vue?vue&type=script&lang=js"
export * from "./CertificateList.vue?vue&type=script&lang=js"

import "./CertificateList.vue?vue&type=style&index=0&id=3044cec2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3044cec2"]])

export default __exports__